import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { registerUser } from "../store/thunk/registerUser";
import { clearMessage } from "../store/actions/action";

function RegisterModal(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [registered, setRegistered] = useState(false);
    const responseError = useSelector((store) => store.response.registerError);

    const dispatch = useDispatch();

    const onClickLogin = () => {
        props.setOpenRegisterModal(false);
        props.setOpenLoginModal(true);

    }

    function validateEmail(email) {
        // Email regex pattern
        var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Test the email against the regex pattern
        return regex.test(email);
    }

    const validateDetails = () => {
        let error;
        if (password.length < 6) {
            error = "Password length should be more than 6."
        }
        else if (isNaN(phone) || phone.length !== 10) {
            error = "Please enter valid phone number."
        }
        else if (!validateEmail(email)) {
            error = "Please enter valid email."
        }
        return error;
    }
    const onClickClose = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setLastName('');
        setEmail('');
        setFirstName('');
        setPassword('');
        setPhone('');
        setError(null);
        setIsLoading(false);
        dispatch(clearMessage());
    }

    const onClickRegister = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsLoading(true);
        const userDetails = {
            FirstName: firstName,
            LastName: lastName,
            Email: email,
            Phone: phone,
            Password: password
        }
        const error = validateDetails();
        if (error) {
            setError(error);
            setIsLoading(false)
            return;
        }
        setLastName('');
        setEmail('');
        setFirstName('');
        setPassword('');
        setPhone('');
        setError(null);

        dispatch(registerUser(userDetails)).then((res) => {
            if (res.payload) {
                setRegistered(true);
            }
        }).finally(() => setIsLoading(false));
    }
    return (
        <div className="modal clean_modal clean_modal-lg" id="register_modal" tabindex="-1" aria-labelledby="register_modal"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <button type="button" id="closeModal" className="close" data-dismiss="modal" aria-label="Close" onClick={(e)=> onClickClose(e)}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="modal-body">
                        {registered && (
                            <div className="text-center py-4">
                                <i className="ti-email" style={{ fontSize: '2.5rem', color: '#28a745' }}></i>
                                <h5 className="mt-3">Check your email!</h5>
                                <p className="text-muted">We sent a verification link to your email address. Please verify your account before logging in.</p>
                                <button className="btn btn-primary btn-rounded mt-2" onClick={(e) => { onClickClose(e); props.setOpenRegisterModal(false); }}>Close</button>
                            </div>
                        )}
                        {!registered && <form onSubmit={(e) => onClickRegister(e)} id="register_form">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <p className="ModalHeader text-muted my-4">Register</p>
                                </div>
                            </div>
                            {(error || responseError) &&
                                <div className="login_error">
                                    <div className=" alert alert-danger" role="alert">
                                        {error || responseError}
                                    </div>
                                </div>}
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group mb-3">
                                        <input className="form-control" required name="fname" placeholder="First Name"
                                            type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group mb-3">
                                        <input className="form-control" required name="lname" placeholder="Last Name"
                                            type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group mb-3">
                                <input name="email" type="email" required placeholder="Email" className="form-control rounded" value={email} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                            <div className="form-group mb-3">
                                <input name="phone" type="text" required placeholder="Phone"
                                    className="form-control rounded checkIsNumber phone-check" value={phone} onChange={(e) => setPhone(e.target.value)} />
                            </div>
                            <div className="form-group mb-3">
                                <input name="password" type="password" required placeholder="Password"
                                    className="form-control rounded" value={password} onChange={(e) => setPassword(e.target.value)} />
                            </div>
                            <button className="btn btn-primary btn-full btn-medium rounded" type="submit" disabled={isLoading}>
                                <span className={`${isLoading ? `spinner-border` : ``} spinner-border-sm`} role="status" aria-hidden="true"></span>
                                Register
                            </button>
                            {/* <button type="submit" id="register_btn" name="submit"
                                className="btn btn-primary btn-full btn-medium rounded" >Register</button> */}

                            <div className="form-group text-center small font-weight-bold mt-3">
                                By continuing you agree to our <a href="#" className='linkClass1'> Terms and conditions.</a>
                            </div>
                            <hr className="my-4" />
                            <div className="form-group text-center small font-weight-bold mb-0">
                                Don&apos;t have an account? <a href="#" className="linkClass1" data-toggle="modal" data-dismiss="modal"
                                    data-target="#login_modal" onClick={onClickLogin}> Login</a>
                            </div>
                        </form>}
                    </div>
                </div>
            </div>
        </div>
    );
}
export default RegisterModal;